import generalTypesRepository from "./generalTypesRepository";
import SliderRepository from "./sliderRepository";
import userRepository from "./userRepository";
import configRepository from "./configRepository";
import notificationRepository from "./notificationRepository";
import roleRepository from "./roleRepository";
import permissionRepository from "./permissionRepository";
import groupRepository from "./groupRepository";
import groupMembersRepository from "./groupMembersRepository";
import tagRepository from "./tagsRepository";

export const repositories = {
  generalTypes: generalTypesRepository,
  slider: SliderRepository,
  userRepository,
  configRepository,
  notificationRepository,
  roleRepository,
  permissionRepository,
  groupRepository,
  groupMembersRepository,
  tag: tagRepository,
};

export const SharedRepositoryFactory = {
  get: name => repositories[name]
};
